import { useLocation } from 'react-router'

import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { useBillingProducts } from '@tribeplatform/react-sdk/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

export const StoreSidebar = () => {
  const { $t } = useI18n()
  const { Link } = useRouter()
  const { pathname, search } = useLocation()
  const fullPath = `${pathname}${search}`
  const { data: billingProducts } = useBillingProducts()

  const planMenuItems = billingProducts?.plans.map(plan => ({
    title: plan.name,
    path: `/manage/app-store/by-plan?planOrder=${plan.order}`,
  }))

  return (
    <NavVertical>
      <NavVertical.Group>
        <SectionHeader
          title={$t({ defaultMessage: 'App store', id: 'Generics.AppStore' })}
          className="px-2 sm:ms-3 pb-3"
        />
        <NavVertical.Item
          active={pathname === '/manage/app-store/integrations'}
          as={Link}
          href="/manage/app-store/integrations"
          leadingAddon={<SvgIcon size="lg" name="grid" className="me-2" />}
        >
          <T
            defaultMessage="Apps & Integrations"
            id="Generics.AppsAndIntegrations"
          />
        </NavVertical.Item>
        <NavVertical.Item
          active={pathname === '/manage/app-store/addons'}
          as={Link}
          href="/manage/app-store/addons"
          leadingAddon={<SvgIcon size="lg" name="zap" className="me-2" />}
        >
          <T defaultMessage="Add-ons" id="Generics.Addons" />
        </NavVertical.Item>
        <SectionHeader
          title={$t({
            defaultMessage: 'Filter by plan',
            id: 'Generics.FilterByPlan',
          })}
          size="sm"
          className="sm:ms-3 pb-1 pt-5"
        />
        {planMenuItems?.map(menuItem => (
          <NavVertical.Item
            key={menuItem.path}
            active={menuItem.path === fullPath}
            as={Link}
            href={menuItem.path}
          >
            {menuItem.title}
          </NavVertical.Item>
        ))}
      </NavVertical.Group>
    </NavVertical>
  )
}
